import { render, staticRenderFns } from "./FileDataDialog.vue?vue&type=template&id=55a3d151&"
import script from "./FileDataDialog.vue?vue&type=script&lang=js&"
export * from "./FileDataDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports